import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { LigacaoTelemarketing } from '../models/ligacao-telemarketing';
import { BuscarKitsVM } from '../models/buscar-kits-vm';
import { AcoesKitDTO } from "../models/acoes-kits";

@Injectable({
  providedIn: 'root'
})
export class KitService {

  constructor(private http: HttpClient) { }

  gerarKits(idPainel, potenciaDe, potenciaAte, tensao, fase, marcaInversor, idFornecedores, telhados, idFornecedoresEstrutura, tipoInv,
    descInicialKit, rangeQtdInversor, opcaoStringbox, marcaStringbox) {
    return this.http.post<any>(globals.apiUrl + '/api/Kit/GerarKits',
      { idPainel, potenciaDe, potenciaAte, tensao, fase, marcaInversor, idFornecedores, telhados, idFornecedoresEstrutura, tipoInv,
        descInicialKit, rangeQtdInversor, opcaoStringbox, idMarcaStringbox: marcaStringbox });
  }

  listarKits(vm: BuscarKitsVM) {
    return this.http.post<any>(globals.apiUrl + '/api/Kit/ListarKits', vm);
  }

  consultarListarKitsSemOrcPedido(idPainel, potenciaDe, potenciaAte, tensao, fase, marcaInversor, idFornecedor, telhados, idFornecedoresEstrutura, tipoInv) {
    return this.http.post<any>(globals.apiUrl + '/api/Kit/ListarKitsSemOrcPedido',
      { idPainel, potenciaDe, potenciaAte, tensao, fase, marcaInversor, idFornecedor, telhados, idFornecedoresEstrutura, tipoInv });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Kit/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  SalvarKits(kits, origem) {
    return this.http.post(globals.apiUrl + '/api/Kit/SalvarKits', { kits: kits, origem: origem });
  }

  SalvarKit(kit) {
    return this.http.post(globals.apiUrl + '/api/Kit/SalvarKit', kit);
  }

  ExcluirKits(kits) {
    return this.http.post(globals.apiUrl + '/api/Kit/ExcluirKits', { kits: kits });
  }

  consultarComposicao(kit) {
    return this.http.post(globals.apiUrl + '/api/Kit/BuscarComposicao', kit);
  }

  consultarTiposDeTelhado() {
    return this.http.get<any>(globals.apiUrl + '/api/Kit/BuscarTiposDeTelhado');
  }

  exportar(vm) {
    return this.http.post(globals.apiUrl + '/api/Kit/Exportar',
      vm,
      { responseType: 'blob' }
    );
  }

  importar(arquivo, menuOrigem) {
    const parametros = new HttpParams()
      .set('menuOrigem', menuOrigem);

    return this.http.post(globals.apiUrl + '/api/Kit/Importar', arquivo, { params: parametros });
  }

  acaoKit(acao: AcoesKitDTO) {
    return this.http.post<any>(globals.apiUrl + '/api/Kit/AcaoKit', acao);
  }
}
